// extracted by mini-css-extract-plugin
export default {"title":"_3WV1","overflowHidden":"_1bZz"};